module.exports = __webpack_public_path__ + "static/media/google-sheets.ee81063b.svg";